import { makeStyles } from '@material-ui/core';
import { motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../theme/theme';
import { Button } from '../../global';
import allSetPicture from './allSet.svg';

const mod = 'AllSetPane';

const useAllSetPaneClasses = makeStyles({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 500,
        padding: 30,
        background: theme.colors.neutral[5],
        '& > *': {
            margin: '0 25px',
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        '& > span:first-child': {
            color: theme.colors.darkBlue[5],
            ...theme.typography.headings.h1,
            marginBottom: 5,
        },
        '& > span:nth-child(2)': {
            color: theme.colors.neutral[1],
            ...theme.typography.content.text,
            marginBottom: 25,
        },
    },
    buttons: {
        display: 'flex',
        margin: '0 -10px',
        '& > *': {
            margin: '0 10px',
        },
    },
});

/**
 * All set pane.
 *
 * @param props.onSchedule callback triggered when the schedule button is clicked
 * @param props.onBack callback triggered when the back button is clicked
 */
export const AllSetPane = (props: { onSchedule?: () => void; onBack?: () => void }) => {
    const classes = useAllSetPaneClasses();
    const { t } = useTranslation(['inspection-creation']);

    return (
        <motion.div className={classes.root}>
            <img src={allSetPicture} alt={t(`${mod}.image-alt`)} />
            <div className={classes.content}>
                <span>{t(`${mod}.title`)}</span>
                <span>{t(`${mod}.subtitle`)}</span>
                <div className={classes.buttons}>
                    <Button variant='contained' onClick={props.onSchedule}>
                        {t(`${mod}.schedule`)}
                    </Button>
                    <Button onClick={props.onBack}>{t(`${mod}.back`)}</Button>
                </div>
            </div>
        </motion.div>
    );
};
